/* eslint-disable max-len */
import React from "react";
import {Link} from "react-router-dom";
import {Box} from "@mui/material";
import {PoliciesStyledBox} from "lib/components";

export default function CookiesPolicy() {
  return (
    <PoliciesStyledBox>
      <Box sx={{width: {xs: "100%", sm: "90%"}}}>
        <h1>Cookies Policy</h1>
        <p>
          <strong>Last updated: April 5, 2025</strong>
        </p>

        <p>
          This Cookies Policy explains what Cookies are and how <strong>Maritime IT Solutions LLC</strong> (&quot;the
          Company,&quot; We,&quot; Us,&quot; or Our&quot;) uses them on <strong>CrewBook</strong> (the
          &quot;Website&quot;). By using the Website, You agree to Our use of Cookies as outlined here. For more details
          on how We handle Your personal data, please refer to Our{" "}
          <a href="https://www.crewbook.app/privacy-policy">Privacy Policy</a>.
        </p>

        <p>
          Cookies are small text files placed on Your device to improve Your experience. They don’t typically contain
          personally identifiable information, but they may link to data We store about You. We do not store sensitive
          personal information—like mailing addresses or passwords—in Cookies, prioritizing the security of seafarer
          data.
        </p>

        <h2>Interpretation and Definitions</h2>
        <h3>Interpretation</h3>
        <p>
          Words with capitalized initial letters have specific meanings defined below. These definitions apply whether
          the terms are singular or plural.
        </p>

        <h3>Definitions</h3>
        <dl>
          <dt>Company</dt>
          <dd>Maritime IT Solutions LLC, based in Delaware, USA.</dd>
          <dt>Cookies</dt>
          <dd>Small files placed on Your device by a website to store browsing details.</dd>
          <dt>Website</dt>
          <dd>
            CrewBook, accessible at <a href="https://www.crewbook.app">https://www.crewbook.app</a>.
          </dd>
          <dt>You</dt>
          <dd>The individual or entity using the Website.</dd>
        </dl>

        <h2>Types of Cookies We Use</h2>
        <p>
          We use both <strong>Session Cookies</strong> (deleted when You close Your browser) and{" "}
          <strong>Persistent Cookies</strong> (retained offline) to enhance Your experience on CrewBook. Here’s what We
          use and why:
        </p>

        <h3>Necessary / Essential Cookies</h3>
        <p>
          <strong>Type</strong>: Session Cookies
        </p>
        <p>
          <strong>Administered by</strong>: Us
        </p>
        <p>
          <strong>Purpose</strong>: These Cookies are vital for core services, such as authentication and security. They
          help prevent fraudulent use of Your Account and ensure You can access features like certificate management and
          data uploads. Without them, the Website may not work properly.
        </p>

        <h3>Functionality Cookies</h3>
        <p>
          <strong>Type</strong>: Persistent Cookies
        </p>
        <p>
          <strong>Administered by</strong>: Us
        </p>
        <p>
          <strong>Purpose</strong>: These Cookies remember Your preferences—like login details, language settings, or
          display options—offering a personalized experience. For seafarers managing certificates and professional data,
          they save time by reducing the need to re-enter information.
        </p>

        <h2>Your Choices Regarding Cookies</h2>
        <p>
          You can manage Your Cookie preferences through Your browser settings or, if available, directly via CrewBook’s
          settings. To disable Cookies:
        </p>
        <ol>
          <li>Go to Your browser’s settings and turn off Cookies.</li>
          <li>Delete existing Cookies linked to this Website.</li>
        </ol>
        <p>
          If You disable Cookies, some features (e.g., auto-login, certificate tracking) may not work as intended. We
          respect Your privacy and will not use Cookies without Your consent.
        </p>

        <h3>Browser-Specific Instructions</h3>
        <p>For help managing Cookies, visit these updated browser pages:</p>
        <ul>
          <li>
            <a href="https://support.google.com/chrome/answer/95647">Google Chrome</a>
          </li>
          <li>
            <a href="https://support.microsoft.com/en-us/microsoft-edge/delete-cookies-in-microsoft-edge-63947406-40ac-c3b8-57b9-2a946a29ae09">
              Microsoft Edge
            </a>
          </li>
          <li>
            <a href="https://support.mozilla.org/en-US/kb/cookies-information-websites-store-on-your-computer">
              Mozilla Firefox
            </a>
          </li>
          <li>
            <a href="https://support.apple.com/en-us/HT201265">Apple Safari</a>
          </li>
        </ul>
        <p>For other browsers, check their official documentation.</p>

        <h2>More Information about Cookies</h2>
        <p>
          To learn more about Cookies, visit <a href="https://www.allaboutcookies.org/">All About Cookies</a>.
        </p>

        <h2>Contact Us</h2>
        <p>Have questions about this Cookies Policy? Reach out to Us:</p>
        <ul>
          <li>
            <strong>Email</strong>: <a href="mailto:watchkeeper@crewbook.app">watchkeeper@crewbook.app</a>
          </li>
          <li>
            <strong>Website</strong>: <Link to="/contact">https://crewbook.app/contact</Link>
          </li>
        </ul>
      </Box>
    </PoliciesStyledBox>
  );
}
